module.exports = __webpack_public_path__ + "img/white.38624a3c.jpg";